import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import { useState, useEffect } from "react";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Inicio from "./components/Inicio";
import Servicios from "./components/Servicios";
import SobreNosotros from "./components/SobreNosotros";
import ComoTrabajamos from "./components/ComoTrabajamos";
import Trayectoria from "./components/Trayectoria";
import Contacto from "./components/Contacto";
import NuestrosExpertos from "./components/NuestrosExpertos";
import ScrollToTopButton from "./components/ScrollToTopButton";

function App() {
  const [mostrarExpertos, setMostrarExpertos] = useState(false);
  const [idioma, setIdioma] = useState("es");
  const [traducciones, setTraducciones] = useState({});

  useEffect(() => {
    fetch(`${process.env.PUBLIC_URL}/languages/${idioma}.json`)
      .then((res) => res.json())
      .then((data) => setTraducciones(data))
      .catch((error) => console.error("Error al cargar traducciones:", error));
  }, [idioma]);

  const cambiarIdioma = (nuevoIdioma) => {
    setIdioma(nuevoIdioma);
  };

  const volverAContactos = () => {
    setMostrarExpertos(false);

    setTimeout(() => {
      const contactoSection = document.getElementById("contacto");
      if (contactoSection) {
        contactoSection.scrollIntoView({ behavior: "smooth" });
      }
    }, 100);
  };
  const volverASobreNosotros = () => {
    setMostrarExpertos(false);

    setTimeout(() => {
      const sobreNosotrosSection = document.getElementById("sobreNosotros");
      if (sobreNosotrosSection) {
        sobreNosotrosSection.scrollIntoView({ behavior: "smooth" });
      }
    }, 100);
  };

  return (
    <div>
      <Header
        setMostrarExpertos={setMostrarExpertos}
        cambiarIdioma={cambiarIdioma}
        traducciones={traducciones}
      />
      <main className="container mt-5">
        {mostrarExpertos ? (
          <section id="expertos" className="row">
            <NuestrosExpertos
              volverAContactos={volverAContactos}
              volverASobreNosotros={volverASobreNosotros}
              traducciones={traducciones}
            />
          </section>
        ) : (
          <>
            <section className="row">
              <Inicio traducciones={traducciones} />
            </section>
            <section id="servicios" className="seccion row my-5">
              <Servicios traducciones={traducciones} />
            </section>
            <section id="sobre" className="seccion row my-5">
              <SobreNosotros
                mostrarExpertos={() => setMostrarExpertos(true)}
                traducciones={traducciones}
              />
            </section>
            <section id="como" className="seccion row my-5">
              <ComoTrabajamos traducciones={traducciones} />
            </section>
            <section id="trayectoria" className="seccion row">
              <Trayectoria traducciones={traducciones} />
            </section>
            <section id="contacto" className="seccion row my-5">
              <Contacto traducciones={traducciones} />
            </section>
          </>
        )}
      </main>
      <Footer traducciones={traducciones} />
      <ScrollToTopButton />
      <footer className="text-center py-3">
        Desarrollada por{" "}
        <a href="https://www.linkedin.com/in/camiloinouerudas/">Camilo Inoue</a>{" "}
        y diseñada por Mario Cárdenas
      </footer>
    </div>
  );
}

export default App;
